import { render, staticRenderFns } from "./GenericEntitySelect.vue?vue&type=template&id=47cb4b6c&"
import script from "./GenericEntitySelect.vue?vue&type=script&lang=ts&"
export * from "./GenericEntitySelect.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports